import React, { Component } from "react";
import Loader from "../../../utils/Loader";
import { toast, ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import {
  cityActionId,
  countryActionId,
  adminUserRoleListActionId,
  toastError,
  toastSuccess,
  roleListActionId,
  exhibitionActionId,
  BASE_URL,
  downloadReport,
} from "../../../utils/constants";
import DatePicker from "react-datepicker";
import Footer from "../../../common_components/Footer";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import {
  getExhStallPossessionDetails_action,
  updateExhStallPossessionChecklist_action,
  tagDDSubmit_action
} from "../../../actions/admin_module_action/exhStallPossessionChecklist_action/exhStallPossessionChecklist_action";
import {
  getStallPossession_action,
  insertStallPossession_action,
} from "../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/stall_possession_action/stall_possession_action";
import { sendNoDues_action } from "../../../actions/admin_module_action/tax_invoice_action/tax_invoice_action";
import {
  emailValidator,
  mobileNoValidator,
  notMendetoryEmailValidator,
} from "../../../utils/Validator";
import ImageCapture from "../../../utils/ImageCapture";
import { download_no_due_action } from "../../../actions/admin_module_action/tax_invoice_action/tax_invoice_action";

class StallPossessionChecklistAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      exhibitionID: "",
      exhibitionList: [],
      basicDetailsList: [],
      checkList: [],
      SignaturePath: "",
      IsSignatureSaved: false,
      SignatureSaveFlag: false,
      RegistrationNO: "",
      hallId: "",
      stallId: "",
      Status: "",
      ITMEStaffName: "",
      IssuedDate: null,
      Remark: "",
      exhCompanyName: "",
      hallNo: "",
      stallNo: "",
      personName: "",
      companyName: "",
      stallPossessionId: "",
      countryId: "",
      contactNo: "",
      email: "",
      isAgree: true,
      remark: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),

      // Err Msg
      personNameErr: "",
      companyNameErr: "",
      contactNoErr: "",
      emailErr: "",
      Status: "",
      ITMEStaffNameErr: "",
      IssuedDateErr: "",
      HallNo_StallNo: "",
      SignatureUUID: "",
      isOpen: false,
      iaMandatory: false,
      vendorList: [],
      vendorIndex: null,
      previousVendorData: [],
      isVendorDDView: false,
      exitPersonName: "",
      exitCompanyName: "",
      exitContactNo: "",
      exitEmail: "",
      exitPersonNameErr: "",
      exitCompanyNameErr: "",
      exitContactNoErr: "",
      exitEmailErr: "",
      isImageModal: false,
      VendorIndex: "",
      IsNDCIssued: false,
      IsAllChecked: false,
      isConfirm: false,
      vendorListIndex: ''
    };
    this.getFillList = this.getFillList.bind(this);
  }

  componentDidMount() {
    this.getFillList(exhibitionActionId, "", "", "", "", "");
    this.getFillList(adminUserRoleListActionId, "", "", "", "", "");
    this.setState(
      {
        ExhRegistrationID:
          this.props.location.state != null &&
          this.props.location.state.ExhRegistrationID,
        exhibitionID:
          this.props.location.state != null &&
          this.props.location.state.ExhibitionID,
        CompanyName:
          this.props.location.state != null &&
            this.props.location.state.CompanyName != null
            ? this.props.location.state.CompanyName
            : null,
        RegistrationNO:
          this.props.location.state != null &&
            this.props.location.state.RegistrationNO != null
            ? this.props.location.state.RegistrationNO
            : null,
        hallId:
          this.props.location.state != null &&
            this.props.location.state.hallId != null
            ? this.props.location.state.hallId
            : null,
        stallId:
          this.props.location.state != null &&
            this.props.location.state.stallId != null
            ? this.props.location.state.stallId
            : null,
        Status:
          this.props.location.state != null &&
            this.props.location.state.Status != null
            ? this.props.location.state.Status
            : null,
      },
      () => {
        this.getStallPossessionChecklistDetails();
        this.getStallPossession();
      }
    );
  }

  getStallPossession() {
    const { ExhRegistrationID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .getStallPossession_action(ExhRegistrationID)
      .then((data) => {
        if (data.error != 1) {
          this.setState({
            exhCompanyName: data.data[0][0]["Exhibitor Compnay Name"] || "",
            hallNo: data.data[0][0]["HallNo"] || "",
            stallNo: data.data[0][0]["StallNo"] || "",
            stallPossessionId: data.data[0][0]["StallPossessionID"] || "",
            countryId: data.data[0][0]["CountryID"] || "",
            personName: data.data[0][0]["PersonName"] || "",
            companyName: data.data[0][0]["CompanyName"] || "",
            contactNo: data.data[0][0]["ContactNo"] || "",
            email: data.data[0][0]["Email"] || "",
            isAgree: data.data[0][0]["IS_Agree"] || false,
            remark: data.data[0][0]["Remark"] || "",
            isLoading: false,
          });
        } else {
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  tagDDSubmit(ExhStallPossessionVendorDDdetailsID, event, isSendMail) {
    const { vendorList, vendorListIndex } = this.state;
    this.setState({ isLoading: true });
    this.props
      .tagDDSubmit_action(ExhStallPossessionVendorDDdetailsID, event, isSendMail)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(event ? 'DD received tagged successfully' : 'DD not receive tagged successfully');
          // this.getStallPossessionChecklistDetails();
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false, isConfirm: false });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  preventMinus = (e) => {
    (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault();
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };

  handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData("text/plain");
    const sanitizedValue = pastedValue.replace(/[-.eE]/g, ""); // Remove '-', '.', 'e', 'E' characters

    // Replace the input value with the sanitized value
    document.execCommand("insertText", false, sanitizedValue);

    event.preventDefault(); // Prevent the default paste behavior
  };

  maxLengthCheck = (object, maxLength) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  // On Back Click
  onCancelClick() {
    this.props.navigate("/manualForms");
  }

  // Input Validate
  inputValidate() {
    const {
      personName,
      companyName,
      contactNo,
      email,
      ITMEStaffName,
      IssuedDate,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
    } = this.state;
    if (personName == "" || personName == null) {
      this.setState({ personNameErr: "Please Enter Person Name" });
    }
    if (companyName == "" || companyName == null) {
      this.setState({ companyNameErr: "Please Enter Company Name" });
    }
    if (contactNo == "" || contactNo == null) {
      this.setState({ contactNoErr: "Please Enter Contact No." });
    }
    if (email == "" || email == null) {
      this.setState({ emailErr: "Please Enter Email" });
    }
    if (exitPersonName == "" || exitPersonName == null) {
      this.setState({ exitPersonNameErr: "Please Enter Person Name" });
    }
    if (exitCompanyName == "" || exitCompanyName == null) {
      this.setState({ exitCompanyNameErr: "Please Enter Company Name" });
    }
    if (exitContactNo == "" || exitContactNo == null) {
      this.setState({ exitContactNoErr: "Please Enter Contact No." });
    }
    if (exitEmail == "" || exitEmail == null) {
      this.setState({ exitEmailErr: "Please enter Email" });
    }
    if (ITMEStaffName == "" || ITMEStaffName == null) {
      this.setState({ ITMEStaffNameErr: "Please Enter ITME Staff Name" });
    }
    if (IssuedDate == null) {
      this.setState({ IssuedDateErr: "Please Select Issued Date" });
    }
    if (email != "") {
      var emailError = emailValidator(email);
      if (emailError != "") {
        this.setState({ emailErr: emailError });
        return;
      }
    }
  }

  checkDuplicates(array, keys) {
    const seen = new Set();
    const duplicates = [];

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      const compositeKey = keys.map((k) => obj[k]).join("|");

      if (seen.has(compositeKey)) {
        duplicates.push({ index: i, values: compositeKey });
      } else {
        seen.add(compositeKey);
      }
    }

    if (duplicates.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  // On Submit
  onSubmit(IsNDCMarked) {
    IsNDCMarked && this.inputValidate();
    const {
      personName,
      companyName,
      contactNo,
      email,
      personNameErr,
      companyNameErr,
      contactNoErr,
      emailErr,
      isAgree,
      remark,
      ITMEStaffName,
      IssuedDate,
      checkList,
      ITMEStaffNameErr,
      IssuedDateErr,
      ExhRegistrationID,
      vendorList,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
    } = this.state;
    console.log("vendorList------------------->", vendorList)
    if (
      IsNDCMarked ? (ITMEStaffName != "" &&
        IssuedDate != null &&
        personName != "" &&
        companyName != "" &&
        contactNo != "" &&
        email != "" &&
        exitPersonName != "" &&
        exitCompanyName != "" &&
        exitContactNo != "" &&
        exitEmail != "") : true
    ) {
      if (
        IsNDCMarked ? (ITMEStaffNameErr == "" &&
          IssuedDateErr == "" &&
          personNameErr == "" &&
          companyNameErr == "" &&
          contactNoErr == "" &&
          emailErr == "") : true
      ) {
        if (IsNDCMarked) {

          const emailValidate = emailValidator(email);
          if (emailValidate) {
            toastError(emailValidate);
            this.setState({ emailErr: emailValidate });
            return;
          }

          const mobileNoValidate = mobileNoValidator(contactNo);
          if (mobileNoValidate) {
            toastError(mobileNoValidate);
            this.setState({ contactNoErr: mobileNoValidate });
            return;
          }

          const emailValidate2 = emailValidator(exitEmail);
          if (emailValidate2) {
            toastError(emailValidate2);
            this.setState({ exitEmailErr: emailValidate2 });
            return;
          }

          const mobileNoValidate2 = mobileNoValidator(exitContactNo);
          if (mobileNoValidate2) {
            toastError(mobileNoValidate2);
            this.setState({ exitContactNoErr: mobileNoValidate2 });
            return;
          }
          const isValid = checkList.every((item) => item.IsChecked);
          if (!isValid) {
            return toastError("Please check all checklist item");
          }

          const isVendorValidate = vendorList.every((item) => item.isAddDD);
          if (!isVendorValidate) {
            this.setState({ iaMandatory: true });
            return toastError("Please add all vendor dd details");
          }
        }

        const array1 = [];
        const array2 = [];
        vendorList.filter(item => !item.isITMEVendor).forEach((item) => {
          array1.push({
            VendorID: item.VendorID || null,
            DD_Number: item.DD_Number || null,
            DD_Date: item.DD_Date ? moment(item.DD_Date).format("YYYY-MM-DD") : null,
            DD_Amount: item.DD_Amount || null,
            BankName: item.DD_BankName || null,
            DDSubmittedByCompanyName: item.DD_SubmitCompanyName || null,
            DDSubmittedByPersonName: item.DD_SubmitPersonName || null,
            DDSubmittedByEmaiID: item.DD_SubmitEmailId || null,
            DDSubmittedByMobileNo: item.DD_SubmitMobileNo || null,
            IsSameAsAbove: item.SameAsAbove || false,
            DDReturnByCompanyName: item.DD_ReturnCompanyName || null,
            DDReturnByPersonName: item.DD_ReturnPersonName || null,
            DDReturnByEmaiID: item.DD_ReturnEmailId || null,
            DDReturnByMobileNo: item.DD_ReturnMobileNo || null,
            DDReturnToCompanyName: item.DD_ReturnToCompanyName || null,
            DDReturnToPersonName: item.DD_ReturnToPersonName || null,
            DDReturnToEmaiID: item.DD_ReturnToEmaiID || null,
            DDReturnToMobileNo: item.DDReturnByMobileNo || null,
            FileName: item.FileName || null,
            FileType: item.FileType || null,
            FilePath: item.FilePath || null,
          });

          item.subContractorList.forEach((data) => {
            array2.push({
              VendorID: item.VendorID || null,
              SubcontractorCompanyName: data.CompanyName || null,
              SubcontractorPersonName: data.PersonName || null,
              SubcontractorEmailID: data.EmailId || null,
              SubcontractorMobileNo: data.MobileNo || null,
            });
          });
        });

        this.setState({ isLoading: true });
        this.props
          .insertStallPossession_action(
            ExhRegistrationID,
            personName,
            companyName,
            contactNo,
            email,
            isAgree,
            remark,
            1,
            array1,
            array2,
            null,
            null,
            {},
            exitPersonName,
            exitCompanyName,
            exitContactNo,
            exitEmail
          )
          .then((data) => {
            if (data.error != 1) {
              this.updateStallPossessionChecklist(IsNDCMarked);
              // this.setState({ isLoading: false });
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toastError("Please Enter Mandatory Fields");
      }
    } else {
      toastError("Please Enter Mandatory Fields");
    }
  }

  async getStallPossessionChecklistDetails() {
    const { exhibitionID, ExhRegistrationID } = this.state;

    this.setState({ isLoading: true });

    try {
      const data = await this.props.getExhStallPossessionDetails_action(
        exhibitionID,
        ExhRegistrationID
      );

      if (data.error === 1) {
        this.setState({ isLoading: false });
        toastError(data.msg);
        return;
      }

      // Basic Details
      const basicDetails = data.data?.[0]?.[0] || {};
      const checklist = data.data?.[1] || [];
      const vendorListData = data.data?.[2] || [];
      const ddDetails = data.data?.[3] || [];
      const subContractorList = data.data?.[4] || [];
      const updatedChecklist = (Array.isArray(checklist) ? checklist : [])
        .map(item => {
          let IsChecked = item.IsChecked;
          if (!basicDetails.IssuedDate) {
            if (item.ChecklistItem?.includes("Demand draft")) {
              IsChecked = basicDetails.isDDSubmitted;
            } else if (item.ChecklistItem?.includes("Exhibitor must clear all space rental")) {
              IsChecked = basicDetails.isFullPIPaid;
            } else if (item.ChecklistItem?.includes("Stall Design Approval")) {
              IsChecked = basicDetails.isStallDesignApprove;
            }
          }
          return {
            ...item,
            IsChecked
          };
        })
        .sort((a, b) => (a?.Seqno ?? 0) - (b?.Seqno ?? 0));


      this.setState({
        basicDetailsList: basicDetails,
        checkList: updatedChecklist,
        ITMEStaffName: basicDetails.ITMEStaffName || "",
        IssuedDate: basicDetails.IssuedDate
          ? moment(basicDetails.IssuedDate, "YYYY-MM-DD HH:mm").toDate()
          : new Date(),
        Remark: basicDetails.Remark || "",
        HallNo_StallNo: basicDetails["HallNo/StallNo"] || "",
        SignatureUUID: basicDetails["SignatureUUID"] || "",

        exitCompanyName: basicDetails.ExitCompanyName,
        exitPersonName: basicDetails.ExitPersonName,
        exitEmail: basicDetails.ExitEmailID,
        exitContactNo: basicDetails.ExitMobileNo,
        IsNDCIssued: basicDetails.IssuedDate ? true : false,
        IsAllChecked: updatedChecklist.every((item) => item.IsChecked),
      });
      // Build vendor array
      const vendorArray = vendorListData.map((vendor) => {
        const isEmpanel = vendor.Empanel == 1;

        // If DD details exist, match them to the vendor (if any)
        const ddInfo =
          ddDetails.find(
            (dd) =>
              dd.VendorID == vendor.VendorID ||
              dd.VendorID == vendor.NonEmpanelVendorID
          ) || {};

      console.log("ddDetails--->", ddDetails)
        return {
          VendorID: vendor.VendorID || vendor.NonEmpanelVendorID,
          PersonName: vendor.VendorName,
          CompanyName: vendor.VendorCompanyName,
          MobileNo: vendor.VendorMobile,
          EmailId: vendor.VendorEmail,
          Type: isEmpanel ? "Empanel" : "Non-Empanel",

          // DD details
          DD_Number: ddInfo.DD_Number || "",
          DD_Amount: ddInfo.DD_Amount || "",
          DD_Date: ddInfo.DD_Date
            ? moment(ddInfo.DD_Date, "YYYY-MM-DD").toDate()
            : null,
          DD_BankName: ddInfo.BankName || "",

          DD_NumberErr: "",
          DD_AmountErr: "",
          DD_DateErr: null,
          DD_BankNameErr: "",

          // DD Submit details
          DD_SubmitPersonName:
            ddInfo.DDSubmittedByPersonName || vendor.VendorName || "",
          DD_SubmitCompanyName:
            ddInfo.DDSubmittedByCompanyName || vendor.VendorCompanyName || "",
          DD_SubmitMobileNo:
            ddInfo.DDSubmittedByMobileNo || vendor.VendorMobile || "",
          DD_SubmitEmailId:
            ddInfo.DDSubmittedByEmaiID || vendor.VendorEmail || "",

          DD_SubmitPersonNameErr: "",
          DD_SubmitCompanyNameErr: "",
          DD_SubmitMobileNoErr: "",
          DD_SubmitEmailIdErr: "",

          // DD Return details
          DD_ReturnPersonName: ddInfo.DDReturnToPersonName || "",
          DD_ReturnCompanyName: ddInfo.DDReturnToCompanyName || "",
          DD_ReturnMobileNo: ddInfo.DDReturnToMobileNo || "",
          DD_ReturnEmailId: ddInfo.DDReturnToEmaiID || "",

          DD_ReturnPersonNameErr: "",
          DD_ReturnCompanyNameErr: "",
          DD_ReturnMobileNoErr: "",
          DD_ReturnEmailIdErr: "",

          FileName: ddInfo.DDReturnToPhotoID
            ? ddInfo.DDReturnToPhotoID.substring(
              ddInfo.DDReturnToPhotoID.lastIndexOf("/") + 1
            )
            : null,
          FilePath: ddInfo.DDReturnToPhotoID || null,
          FileType: null,
          FileNameErr: "",

          SameAsAbove: ddInfo.IsSameAsAbove || false,
          isITMEVendor: isEmpanel,
          subContractorList: subContractorList
            .filter(
              (item) =>
                item.VendorID == vendor.VendorID ||
                item.VendorID == vendor.NonEmpanelVendorID
            )
            .map((item) => ({
              VendorID: item.VendorID,
              CompanyName: item.SubContractorCompanyName,
              PersonName: item.SubContractorPersonName,
              MobileNo: item.SubContractorMobileNo,
              EmailId: item.SubcontractorEmailID,
            })),
          isAddDD: isEmpanel ? true : ddDetails.length > 0,
          ServiceName: vendor.ServiceName || "",
          IsDDSubmitted: ddInfo.IsDDSubmitted,
          ExhStallPossessionChecklistHdrID: ddInfo.ExhStallPossessionChecklistHdrID,
          ExhStallPossessionVendorDDdetailsID: ddInfo.ExhStallPossessionVendorDDdetailsID,
        };
      }).sort((a, b) => b.isITMEVendor - a.isITMEVendor);

      this.setState({ vendorList: vendorArray });

      const ddItem = updatedChecklist.find((item) => item.IsDDshow);
      this.setState({ isVendorDDView: ddItem ? ddItem.IsChecked : false });

      this.setState({ isLoading: false });
    } catch (err) {
      this.setState({ isLoading: false });
      toastError(
        "Something went wrong while fetching stall possession details."
      );
    }
  }

  updateStallPossessionChecklist(IsNDCMarked) {
    const {
      exhibitionID,
      ExhRegistrationID,
      SignaturePath,
      checkList,
      basicDetailsList,
      ITMEStaffName,
      IssuedDate,
      Remark,
      vendorList,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
      IsNDCIssued,
    } = this.state;
    const array1 = [];
    const array2 = [];
    vendorList.forEach((item) => {
      if (item.Type == "Non-Empanel") {
        array1.push({
          VendorID: item.VendorID || null,
          DD_Number: item.DD_Number || null,
          DD_Date: item.DD_Date
            ? moment(item.DD_Date).format("YYYY-MM-DD")
            : null,
          DD_Amount: item.DD_Amount || null,
          BankName: item.DD_BankName || null,
          DDSubmittedByCompanyName: item.DD_SubmitCompanyName || null,
          DDSubmittedByPersonName: item.DD_SubmitPersonName || null,
          DDSubmittedByEmaiID: item.DD_SubmitEmailId || null,
          DDSubmittedByMobileNo: item.DD_SubmitMobileNo || null,
          IsSameAsAbove: item.SameAsAbove || false,
          DDReturnByCompanyName: item.DD_ReturnCompanyName || null,
          DDReturnByPersonName: item.DD_ReturnPersonName || null,
          DDReturnByEmaiID: item.DD_ReturnEmailId || null,
          DDReturnByMobileNo: item.DD_ReturnMobileNo || null,
          DDReturnToCompanyName: item.DD_ReturnToCompanyName || null,
          DDReturnToPersonName: item.DD_ReturnToPersonName || null,
          DDReturnToEmaiID: item.DD_ReturnToEmaiID || null,
          DDReturnToMobileNo: item.DDReturnByMobileNo || null,
          FileName: item.FileName || null,
          FileType: item.FileType || null,
          FilePath: item.FilePath || null,
          IsDDSubmitted: item.IsDDSubmitted || false,
        });

        item.subContractorList.forEach((data) => {
          array2.push({
            VendorID: item.VendorID || null,
            SubcontractorCompanyName: data.CompanyName || null,
            SubcontractorPersonName: data.PersonName || null,
            SubcontractorEmailID: data.EmailId || null,
            SubcontractorMobileNo: data.MobileNo || null,
          });
        });
      }
    });

    const formatdate = IssuedDate
      ? moment(IssuedDate).format("YYYY-MM-DD HH:mm")
      : null;

    this.props
      .updateExhStallPossessionChecklist_action(
        exhibitionID,
        basicDetailsList.ExhRegistrationNo,
        ExhRegistrationID,
        ITMEStaffName,
        formatdate,
        Remark,
        checkList,
        exitPersonName,
        exitCompanyName,
        exitContactNo,
        exitEmail,
        array1,
        array2,
        IsNDCMarked
      )
      .then((data) => {
        if (data.error != 1) {
          if (IsNDCMarked) {
            this.setState({ isLoading: false });
            toastSuccess(
              IsNDCIssued
                ? "Stall possession updated successfully!"
                : "NDC issued marked successfully!"
            );
            if (!IsNDCIssued) {
              this.sendNoDues();
            }
            setTimeout(() => {
              window.history.back();
            }, 2000);
          } else {
            toastSuccess("DD details added successfully!")
            // this.getStallPossessionChecklistDetails()
            this.setState({ isLoading: false });
          }

        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  viewNoDues() {
    const { exhibitionID, ExhRegistrationID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .download_no_due_action(exhibitionID, ExhRegistrationID)
      .then((data) => {
        if (data.error != 1) {
          console.log("jjjjjjjjjjjjjjj", data);
          var url = `${downloadReport}?SessionIdentifier=${data}`;
          const win = window.open(url, "_blank");

          if (win) {
            win.focus();
          }

          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });

          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID === exhibitionActionId) {
            this.setState({
              exhibitionList: data.data,
            });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleCheck = (category, item) => {
    const newData = this.state.checkList.map((d) => {
      if (d.Category === category && d.ChecklistItem === item) {
        console.log("d.IsDDshow--------------->", d.IsDDshow);
        if (d.IsDDshow && !d.IsChecked) {
          this.setState({ isVendorDDView: true });
        } else if (d.IsDDshow) {
          this.setState({ isVendorDDView: false });
        }
        return { ...d, IsChecked: !d.IsChecked };
      }
      return d;
    });

    this.setState({
      checkList: newData,
      IsAllChecked: newData.every((item) => item.IsChecked),
    });
  };

  groupByCategory = () => {
    return this.state.checkList.reduce((acc, item) => {
      acc[item.Category] = acc[item.Category] || [];
      acc[item.Category].push(item);
      return acc;
    }, {});
  };

  SignatureRef = React.createRef();
  clearOppSignature = () => {
    this.SignatureRef.current.clear();
    this.setState({
      IsSignatureSaved: false,
    });
  };
  clearOppSaveSignatureImg = () => {
    this.setState({
      SignaturePath: "",
      IsSignatureSaved: false,
      SignatureSaveFlag: false,
    });
  };
  saveOppSignature = () => {
    const SignaturePath = this.SignatureRef.current.toDataURL();

    if (this.SignatureRef.current.isEmpty() == false) {
      this.setState({
        SignaturePath: SignaturePath,
        IsSignatureSaved: true,
        SignatureSaveFlag: true,
      });
    } else {
      toastError("Please add signature!");
    }
  };

  handleCancel() {
    const {
      exhibitionID,
      CompanyName,
      RegistrationNO,
      hallId,
      stallId,
      Status,
    } = this.state;
    this.props.navigate("/stallPossessionChecklistList", {
      state: {
        ExhibitionID: exhibitionID,
        CompanyName: CompanyName,
        RegistrationNO: RegistrationNO,
        hallId: hallId,
        stallId: stallId,
        Status: Status,
      },
    });
  }

  // On Send No Dues
  sendNoDues() {
    const { ExhRegistrationID, SignatureUUID } = this.state;
    var list = [
      {
        ExhregistrationID: parseInt(ExhRegistrationID),
        hallStall: SignatureUUID,
      },
    ];
    this.setState({ isLoading: true });
    this.props
      .sendNoDues_action(list)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toastSuccess("No Dues Send Successfully");
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleInput = async (e, type, field, parentIndex, childIndex = null, ExhStallPossessionVendorDDdetailsID) => {
    const updatedList = structuredClone(this.state.vendorList); // deep clone
    let Value;

    // Determine the input value
    if (type === "date") {
      Value = e.target?.value || e; // handle both cases
    } else if (type === "int") {
      Value = e.target.value.replace(/\D/g, "");
    } else if (type === "checkbox") {
      Value = e.target.checked;
    } else if (type === "file") {
      Value = e.target.files;
    } else {
      Value = e.target.value;
    }

    if (field == 'IsDDSubmitted') {
      if (e.target.checked) {
        this.setState({ isConfirm: true, ExhStallPossessionVendorDDdetailsID: ExhStallPossessionVendorDDdetailsID, vendorListIndex: parentIndex })
      } else {
        this.tagDDSubmit(ExhStallPossessionVendorDDdetailsID, Value, false)
      }
    }

    const errorField = `${field}Err`;

    if (childIndex !== null) {
      // --- Subcontractor level update ---
      updatedList[parentIndex].subContractorList[childIndex][field] = Value;

      if (
        updatedList[parentIndex].subContractorList[childIndex][errorField] !==
        undefined &&
        Value !== ""
      ) {
        updatedList[parentIndex].subContractorList[childIndex][errorField] = "";
      }
    } else {
      // --- Parent-level update ---
      updatedList[parentIndex][field] = Value;

      const vendor = updatedList[parentIndex];
      if (field == 'IsDDSubmitted') {
        vendor.IsDDSubmitted = e.target.checked
      }
      // Apply "SameAsAbove" only when toggled on
      if (field === "SameAsAbove") {
        if (Value) {
          vendor.DD_ReturnPersonName = vendor.DD_SubmitPersonName;
          vendor.DD_ReturnCompanyName = vendor.DD_SubmitCompanyName;
          vendor.DD_ReturnMobileNo = vendor.DD_SubmitMobileNo;
          vendor.DD_ReturnEmailId = vendor.DD_SubmitEmailId;
        } else {
          vendor.DD_ReturnPersonName = "";
          vendor.DD_ReturnCompanyName = "";
          vendor.DD_ReturnMobileNo = "";
          vendor.DD_ReturnEmailId = "";
        }
        vendor.DD_ReturnPersonNameErr = "";
        vendor.DD_ReturnCompanyNameErr = "";
        vendor.DD_ReturnMobileNoErr = "";
        vendor.DD_ReturnEmailIdErr = "";
      }

      if (field === "Document") {
        const fileData = await this.onFilePick(e, Value);
        vendor.FileName = fileData.FileName;
        vendor.FilePath = fileData.FilePath;
        vendor.FileType = fileData.FileType;
        vendor.FileNameErr = "";
      }

      if (updatedList[parentIndex][errorField] !== undefined && Value !== "") {
        updatedList[parentIndex][errorField] = "";
      }
    }
    // Always update state after modification
    this.setState({ vendorList: updatedList });
  };

  handleDelete = (parentIndex, childIndex) => {
    const updatedList = [...this.state.vendorList];
    updatedList[parentIndex].subContractorList = updatedList[
      parentIndex
    ].subContractorList.filter((_, i) => i !== childIndex);
    this.setState({ vendorList: updatedList });
  };

  onSaveModal = () => {
    const { vendorList, vendorIndex } = this.state;
    const vendor = vendorList[vendorIndex];

    let isValid = true;
    let errors = {};
    let toastMessage = ""; // track one toast message

    // --- Validate main mandatory DD fields ---
    const mandatoryFields = [
      { key: "DD_Number", label: "DD Number" },
      { key: "DD_Amount", label: "DD Amount" },
      { key: "DD_Date", label: "DD Date", isDate: true },
      { key: "DD_BankName", label: "Bank Name" },
      { key: "DD_SubmitCompanyName", label: "Company Name" },
      { key: "DD_SubmitPersonName", label: "Person Name" },
      { key: "DD_SubmitMobileNo", label: "Mobile No." },
      { key: "DD_SubmitEmailId", label: "Email Id." },
      { key: "DD_ReturnCompanyName", label: "Company Name" },
      { key: "DD_ReturnPersonName", label: "Person Name" },
      { key: "DD_ReturnMobileNo", label: "Mobile No." },
      { key: "DD_ReturnEmailId", label: "Email Id." },
      { key: "FileName", label: "Documents" },
    ];

    let hasMandatoryError = false;
    for (let field of mandatoryFields) {
      const value = vendor[field.key];
      const isEmpty = field.isDate
        ? !value
        : value === null ||
        value === undefined ||
        (typeof value === "string" && !value.trim());

      console.log("isEmpty--->", isEmpty);
      if (isEmpty) {
        errors[`${field.key}Err`] = `Please enter ${field.label}`;
        hasMandatoryError = true;
        isValid = false;
      }
    }

    if (hasMandatoryError) {
      toastMessage = "Please enter mandatory fields"; // highest priority
    }

    // --- Validate subContractorList mandatory rows ---
    if (
      !hasMandatoryError &&
      vendor.subContractorList &&
      vendor.subContractorList.length > 0
    ) {
      const hasEmptySubRows = vendor.subContractorList.some(
        (sub) =>
          !sub.PersonName ||
          !sub.PersonName.trim() ||
          !sub.CompanyName ||
          !sub.CompanyName.trim() ||
          !sub.MobileNo ||
          !sub.MobileNo.trim() ||
          !sub.EmailId ||
          !sub.EmailId.trim()
      );

      if (hasEmptySubRows) {
        toastMessage = "Please fill all rows in the sub-contractor table!";
        isValid = false;
      }
    }

    const checkDuplicate = this.checkDuplicates(vendor.subContractorList, [
      "PersonName",
      "CompanyName",
      "MobileNo",
      "EmailId",
    ]);
    if (checkDuplicate) {
      toastMessage =
        "Duplicate records cannot be insert in the sub-contractor table!";
      isValid = false;
    }

    // --- Validate emails only if no mandatory or sub-contractor row errors ---
    if (!hasMandatoryError && !toastMessage) {
      const submitEmailError = emailValidator(
        vendor.DD_SubmitEmailId?.trim() || ""
      );
      if (submitEmailError) {
        errors.DD_SubmitEmailIdErr = submitEmailError;
        isValid = false;
        toastMessage = submitEmailError;
      }

      const submitMobileError = mobileNoValidator(
        vendor.DD_SubmitMobileNo?.trim() || ""
      );
      if (submitMobileError) {
        errors.DD_SubmitMobileNoErr = submitMobileError;
        isValid = false;
        toastMessage = submitMobileError;
      }

      const returnEmailError = emailValidator(
        vendor.DD_ReturnEmailId?.trim() || ""
      );
      if (returnEmailError) {
        errors.DD_ReturnEmailIdErr = returnEmailError;
        isValid = false;
        if (!toastMessage) toastMessage = returnEmailError;
      }

      const returnMobileError = mobileNoValidator(
        vendor.DD_ReturnMobileNo?.trim() || ""
      );
      if (returnMobileError) {
        errors.DD_ReturnMobileNoErr = returnMobileError;
        isValid = false;
        toastMessage = returnMobileError;
      }

      // --- Sub-contractor email validation ---
      if (vendor.subContractorList && vendor.subContractorList.length > 0) {
        const hasInvalidEmail = vendor.subContractorList.some((sub) => {
          const emailErr = emailValidator(sub.EmailId?.trim() || "");
          return emailErr !== "";
        });

        if (hasInvalidEmail && !toastMessage) {
          toastMessage =
            "Please enter valid email addresses in sub-contractors!";
          isValid = false;
        }

        const hasInvalidMobile = vendor.subContractorList.some((sub) => {
          const MobileNoErr = mobileNoValidator(sub.MobileNo?.trim() || "");
          return MobileNoErr !== "";
        });

        if (hasInvalidMobile && !toastMessage) {
          toastMessage = "Please enter valid contact no in sub-contractors!";
          isValid = false;
        }
      }
    }

    // --- Handle Validation Failures ---
    if (!isValid) {
      toastError(toastMessage); // only one toast

      this.setState((prevState) => {
        const updatedList = [...prevState.vendorList];
        updatedList[vendorIndex] = { ...vendor, ...errors };
        return { vendorList: updatedList };
      });
    } else {
      // --- Save Valid Data ---
      this.setState((prevState) => {
        const updatedList = [...prevState.vendorList];
        updatedList[vendorIndex] = { ...vendor, isAddDD: true };
        return {
          vendorList: updatedList,
          isOpen: !vendor.isAddDD,
          vendorIndex: !vendor.isAddDD ? this.state.vendorIndex : null,
          previousVendorData: null,
        };
      }, () => !vendor.isAddDD && this.onSubmit(false));
    }

    return isValid;
  };

  handleModalCancel = () => {
    const { vendorIndex, previousVendorData, vendorList } = this.state;

    if (previousVendorData && vendorIndex !== null) {
      // const restored = [...vendorList];
      // restored[vendorIndex] = JSON.parse(JSON.stringify(previousVendorData));
      this.setState({
        // vendorList: restored,
        isOpen: false,
        vendorIndex: null,
        previousVendorData: null,
      });
    } else {
      this.setState({ isOpen: false });
    }
  };

  openModal = (index) => {
    const vendor = this.state.vendorList[index];
    if (!vendor || Array.isArray(vendor)) {
      console.warn("⚠️ Invalid vendor data at index", index, vendor);
      return;
    }

    const backup = JSON.parse(JSON.stringify(vendor));
    this.setState({
      isOpen: true,
      vendorIndex: index,
      previousVendorData: backup,
    });
  };

  onFilePick = async (e, file) => {
    e.preventDefault();
    console.log("file--->", file);
    const { childList, allowedFileTypes } = this.state;
    if (file[0]["size"] > 5242880) {
      toast.error("File size more than 5mb are not allow.", {
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      // Clear the file input field
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = ""; // Clear the input value
      }

      return;
    } else {
      var image = "";
      if (
        file[0]["name"].toString().toLowerCase().includes(".pdf") ||
        file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
        file[0]["name"].toString().toLowerCase().includes(".png") ||
        file[0]["name"].toString().toLowerCase().includes(".jpg")
      ) {
        image = await this.convertToBase64(file[0]);

        return {
          FilePath: image,
          FileName: file[0]["name"],
          FileType: file[0]["name"].split(".")[1],
        };
      } else {
        toast.error(
          `Allowed File types .jpg,.jpeg,.png,.pdf with maximum size 5 MB`,
          {
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          }
        );
        // Clear the file input field
        document.getElementById("inputGroupFile").value = "";

        return;
      }
    }
  };

  convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  handleViewFile = (base64String, fileName) => {
    // Extract MIME type and Base64 data
    const mimeType = base64String.split(";")[0].split(":")[1]; // Extract MIME type (e.g., 'image/png' or 'application/pdf')
    const byteCharacters = atob(base64String.split(",")[1]); // Extract Base64 content
    const byteNumbers = Array.from(byteCharacters).map((char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // Create a URL for the Blob
    const fileURL = URL.createObjectURL(blob);

    if (mimeType.startsWith("image/") || mimeType === "application/pdf") {
      // Open viewable files directly
      const newTab = window.open(fileURL, "_blank", "noopener,noreferrer");
      if (newTab) {
        newTab.document.title = fileName; // Set the tab title to the file name
      }
    } else {
      // Download non-viewable files
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName; // Use the specific file name for the download
      link.click();
    }

    // Clean up the blob URL after the file action
    setTimeout(() => URL.revokeObjectURL(fileURL), 500);
  };

  handleRemoveFile = (index) => {
    this.setState((prevState) => {
      const updatedList = [...prevState.vendorList];
      updatedList[index] = {
        ...updatedList[index],
        FileName: null,
        FileType: null,
        FilePath: null,
      };
      return { vendorList: updatedList };
    });
  };

  handleOpenModal = (index) => {
    this.setState({ isImageModal: true, VendorIndex: index });
  };

  handleCloseModal = () => {
    this.setState({ isImageModal: false });
  };

  handleCapture = (imageData) => {
    const { VendorIndex } = this.state;
    this.setState((prevState) => {
      const updatedList = [...prevState.vendorList];
      updatedList[VendorIndex] = {
        ...updatedList[VendorIndex],
        FileName: "Document",
        FileType: "jpeg",
        FilePath: imageData,
        FileNameErr: "",
      };
      return { vendorList: updatedList };
    });
    this.setState({ isImageModal: false });
  };

  handleIsAllChecked(e) {
    const event = e.target.checked;
    this.setState({ IsAllChecked: event });
    const newData = this.state.checkList.map((d) => {
      if (event) {
        this.setState({ isVendorDDView: true });
      } else if (d.IsDDshow) {
        this.setState({ isVendorDDView: false });
      }
      return { ...d, IsChecked: event };
    });
    this.setState({ checkList: newData });
  }

  render() {
    const {
      isLoading,
      exhibitionID,
      exhibitionList,
      basicDetailsList,
      SignaturePath,
      IsSignatureSaved,
      SignatureSaveFlag,
      ITMEStaffName,
      IssuedDate,
      Remark,
      exhCompanyName,
      hallNo,
      stallNo,
      companyName,
      personName,
      contactNo,
      email,
      isAgree,
      remark,
      personNameErr,
      companyNameErr,
      countryId,
      contactNoErr,
      emailErr,
      currentDate,
      Status,
      ITMEStaffNameErr,
      IssuedDateErr,
      checkList,
      isOpen,
      vendorIndex,
      vendorList,
      iaMandatory,
      exitPersonName,
      exitCompanyName,
      exitContactNo,
      exitEmail,
      exitPersonNameErr,
      exitCompanyNameErr,
      exitContactNoErr,
      exitEmailErr,
      isVendorDDView,
      isImageModal,
      IsNDCIssued,
      IsAllChecked,
      isConfirm
    } = this.state;

    console.log("vendorList---------->", vendorList);

    const grouped = this.groupByCategory();
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <div
          className={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? "with-dr-container"
              : "with-dr-container com-height"
          }
        >
          <div className="row">
            <div className="breadcrumb-scroll-fixed">
              <h6 className="mb-0 px-2 py-2 text-white">
                Stall Possession Checklist Update
              </h6>
            </div>
          </div>
          <div className="main-content admin-top-space">
            <AdminDrawer />
          </div>
          <div class="container-fluid">
            <div className="row">
              <div className="container mt-3">
                <div className="card shadow-none border rounded-3 p-0">
                  <div
                    className="card shadow-none rounded-3 mb-0 border-0">
                    <div
                      className="card-header  text-dark py-2 bg-card-header">
                      Exhibitor's Details
                    </div>
                    <div className="card-body d-flex flex-wrap gap-4 py-3 px-2">
                      <div>
                        <span className="fw-normal text-muted">
                          Registration No:
                        </span>{" "}
                        {basicDetailsList.ExhRegistrationNo || "-"}
                      </div>
                      <div>
                        <span className="fw-normal text-muted">Company:</span>{" "}
                        {basicDetailsList.ExhibitorCompanyName || "-"}
                      </div>
                      <div>
                        <span className="fw-normal text-muted">Country:</span>{" "}
                        {basicDetailsList.CountryName || "-"}
                      </div>
                      <div>
                        <span className="fw-normal text-muted">Hall:</span>{" "}
                        {basicDetailsList.HallName || "-"}
                      </div>
                      <div>
                        <span className="fw-normal text-muted">Stall:</span>{" "}
                        {basicDetailsList.StallName || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card shadow-none border rounded-3 p-0">
              <div
                className="card-header  text-dark py-2 bg-card-header">
                Representative for Stall Possession
              </div>
              <div class="card-body row pt-3 m-0 border">
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Person Name<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={personName}
                    maxLength={100}
                    onChange={(e) =>
                      this.setState({
                        personName: e.target.value.replace(/[^a-zA-Z ]/g, ""),
                        personNameErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {personNameErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Company Name<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={companyName}
                    maxLength={200}
                    onChange={(e) =>
                      this.setState({
                        companyName: e.target.value,
                        companyNameErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {companyNameErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Contact No<span className="text-red">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={contactNo}
                    // maxLength={countryId == 91 ? 10 : 20}
                    maxLength={10}
                    // onInput={(e) => this.maxLengthCheck(e, countryId == 91 ? 10 : 20)}
                    onInput={(e) => this.maxLengthCheck(e, 20)}
                    onKeyDown={(e) => this.preventMinus(e)}
                    onWheel={(e) => e.target.blur()}
                    onPaste={(e) => this.handlePaste(e)}
                    onChange={(e) =>
                      this.setState({
                        contactNo: e.target.value.replace(/\D/g, ""),
                        contactNoErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {contactNoErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Email ID<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={email}
                    maxLength={100}
                    onChange={(e) =>
                      this.setState({ email: e.target.value, emailErr: "" })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {emailErr}
                    </span>
                  }
                </div>
                {/* <div className="col-md-4">
                                <fieldset className="d-flex mt-3 mb-4">
                                    <button
                                        className="btn rounded-0 btn-primary"
                                        style={{ padding: "3px 7px", marginRight: 10 }}
                                        disabled={currentDate > DeadlineDate}
                                        onClick={(e) => this.onSubmit()}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        className="btn rounded-0 btn-dark"
                                        style={{ padding: "3px 7px" }}
                                        onClick={(e) => this.onCancelClick(e)}
                                    >
                                        Back
                                    </button>
                                </fieldset>
                            </div> */}
              </div>
            </div>

            <div className="card shadow-none border rounded-3 p-0">
              <div
                className="card-header  text-dark py-2 bg-card-header">
                Representative for Exit
              </div>
              <div class="card-body row pt-3">
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Person Name<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={exitPersonName}
                    maxLength={100}
                    onChange={(e) =>
                      this.setState({
                        exitPersonName: e.target.value.replace(
                          /[^a-zA-Z ]/g,
                          ""
                        ),
                        exitPersonNameErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {exitPersonNameErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Company Name<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={exitCompanyName}
                    maxLength={200}
                    onChange={(e) =>
                      this.setState({
                        exitCompanyName: e.target.value,
                        exitCompanyNameErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {exitCompanyNameErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Contact No<span className="text-red">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={exitContactNo}
                    // maxLength={countryId == 91 ? 10 : 20}
                    maxLength={10}
                    // onInput={(e) => this.maxLengthCheck(e, countryId == 91 ? 10 : 20)}
                    onInput={(e) => this.maxLengthCheck(e, 20)}
                    onKeyDown={(e) => this.preventMinus(e)}
                    onWheel={(e) => e.target.blur()}
                    onPaste={(e) => this.handlePaste(e)}
                    onChange={(e) =>
                      this.setState({
                        exitContactNo: e.target.value.replace(/\D/g, ""),
                        exitContactNoErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {exitContactNoErr}
                    </span>
                  }
                </div>
                <div className="col-xl-3">
                  <label htmlFor="validationCustom03">
                    Email ID<span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={exitEmail}
                    maxLength={100}
                    onChange={(e) =>
                      this.setState({
                        exitEmail: e.target.value,
                        exitEmailErr: "",
                      })
                    }
                  />
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {exitEmailErr}
                    </span>
                  }
                </div>
              </div>
            </div>

            <div class="row m-0">
              <table class="table align-middle">
                <thead style={{ background: "#f2f2f2" }}>
                  <tr>
                    <th style={{ width: "250px" }}>Category</th>
                    <th>Checklist Item</th>
                    <th style={{ width: "100px" }} className="text-center">
                      <input
                        type="checkbox"
                        className="mt-2"
                        checked={IsAllChecked}
                        disabled={IsNDCIssued}
                        onChange={(e) => this.handleIsAllChecked(e)}
                      />
                      Status (
                      {checkList.filter((item) => item.IsChecked).length}/
                      {checkList.length})
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(grouped).map((category) =>
                    grouped[category].map((item, index) => (
                      <tr key={category + index}>
                        {/* Show category name only for first row of each group */}
                        {index === 0 ? (
                          <td
                            rowSpan={grouped[category].length}
                            className="p-2 border font-semibold"
                          >
                            {category}
                          </td>
                        ) : null}
                        <td className="p-2 border wrap-break-td">
                          {item.ChecklistItem}
                        </td>
                        <td className="p-2 border text-center">
                          <input
                            type="checkbox"
                            checked={item.IsChecked}
                            disabled={IsNDCIssued}
                            onChange={() =>
                              this.handleCheck(category, item.ChecklistItem)
                            }
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {isVendorDDView && vendorList.length > 0 ? (
                <div
                  className="row g-3"
                  style={{ maxHeight: 500, overflowY: "auto" }}
                >
                  {vendorList.map((item, i) =>
                    item.isITMEVendor ? (
                      <div className="col-md-3 col-sm-4">
                        <div className="card border-0 rounded-3 shadow-sm bg-light">
                          <div className="card-body p-2 pb-4 d-flex align-items-start">
                            <div>
                              <h6 className="mb-1 fw-bold text-muted">
                                <i className="fa fa-user text-secondary" />{" "}
                                {item.PersonName}
                              </h6>
                              <p className="mb-0 small text-muted">
                                <i class="fa fa-cog me-1"></i>{" "}
                                {item.ServiceName}
                              </p>
                              <p className="mb-1 small text-muted">
                                <i className="fa fa-building-o me-1 text-dark" />{" "}
                                {item.CompanyName}
                              </p>
                              <p className="mb-0 small text-muted">
                                <i className="fa fa-phone me-1 text-danger" />{" "}
                                {item.EmailId}
                              </p>
                              <p className="mb-0 small text-muted">
                                <i className="fa fa-envelope-o me-1 text-primary" />
                                {item.MobileNo}
                              </p>
                              <p className="mb-0 small text-muted fw-bold">
                                <i className="fa fa-circle text-muted " />{" "}
                                &nbsp;{item.Type}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-md-3 col-sm-4">
                        {item.isAddDD ? (
                          <div
                            className="card border-0 rounded-3 shadow-sm"
                            style={{ borderLeft: "5px solid #198754" }}
                          >
                            <div className="card-body p-2 d-flex align-items-start">
                              <div>
                                <h6 className="mb-1 fw-bold text-success">
                                  <i className="fa fa-user text-success" />{" "}
                                  {item.PersonName}
                                </h6>
                                <p className="mb-0 small text-muted">
                                  <i class="fa fa-cog me-1 text-dark"></i>{" "}
                                  {item.ServiceName}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-building-o me-1 text-dark" />{" "}
                                  {item.CompanyName}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-envelope-o me-1 text-primary" />
                                  {item.EmailId}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-phone me-1 text-success" />{" "}
                                  {item.MobileNo}
                                </p>
                                <p className="mb-0 small text-success fw-bold">
                                  <i className="fa fa-circle text-success" />
                                  &nbsp;{item.Type}
                                </p>
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.openModal(i)}
                                >
                                  <span className="badge bg-primary text-white fw-normal">
                                    Update DD Details
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={`shadow-sm ${iaMandatory ? "blink-border" : ""
                              }`}
                            style={{
                              backgroundColor: "white",
                              border: iaMandatory ? "2px solid red" : "none", // fallback for non-animated
                            }}
                          >
                            <div className="card-body p-2 d-flex align-items-start">
                              <div>
                                <h6 className="mb-1 fw-bold text-warning">
                                  <i className="fa fa-user text-warning" />{" "}
                                  {item.PersonName}
                                </h6>
                                <p className="mb-0 small text-muted">
                                  <i class="fa fa-cog me-1 text-dark"></i>{" "}
                                  {item.ServiceName}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-building-o me-1 text-dark" />{" "}
                                  {item.CompanyName}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-envelope-o me-1 text-primary" />{" "}
                                  {item.EmailId}
                                </p>
                                <p className="mb-0 small text-muted">
                                  <i className="fa fa-phone me-1 text-warning" />{" "}
                                  {item.MobileNo}
                                </p>
                                <p className="mb-0 small text-warning fw-bold">
                                  <i className="fa fa-circle text-warning" />{" "}
                                  {item.Type}
                                </p>
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.openModal(i)}
                                >
                                  <span className="badge bg-warning text-white fw-normal">
                                    Add DD Details
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  )}
                </div>
              ) : <></>}
            </div>
            <div className="row">
              <div className="col-md-4">
                <label className="col-form-label">
                  ITME Staff Name<span className="text-red">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={ITMEStaffName}
                  disabled={IsNDCIssued}
                  onChange={(e) =>
                    this.setState({
                      ITMEStaffName: e.target.value.replace(/[^a-zA-Z ]/g, ""),
                      ITMEStaffNameErr: "",
                    })
                  }
                />
                {
                  <span className="text-danger text-start text-left d-block mt-1">
                    {ITMEStaffNameErr}
                  </span>
                }
              </div>
              <div className="col-md-4">
                <label className="col-form-label">
                  Issued Date<span className="text-red">*</span>
                </label>
                <DatePicker
                  selected={IssuedDate ? moment(IssuedDate).toDate() : null}
                  disabled={IsNDCIssued}
                  minDate={new Date()}
                  minTime={new Date()}
                  maxTime={new Date().setHours(23, 59, 59, 999)}
                  onChange={(e) =>
                    this.setState({ IssuedDate: e, IssuedDateErr: "" })
                  }
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={1} // choose time in 15-min steps
                  dateFormat="dd-MM-yyyy HH:mm"
                  placeholderText="Select date and time"
                  className="form-control"
                />
                {
                  <span className="text-danger text-start text-left d-block mt-1">
                    {IssuedDateErr}
                  </span>
                }
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                <label className="col-form-label">Remark</label>
                <textarea
                  type="text"
                  className="form-control"
                  rows={4}
                  value={Remark}
                  maxLength={1000}
                  onChange={(e) => this.setState({ Remark: e.target.value })}
                />
              </div>
            </div>

            <div className="mb-5 text-end p-0 py-2 mt-3">
              <button
                className="btn btn-aqua mx-2"
                onClick={() => this.onSubmit(true)}
              >
                {" "}
                {IsNDCIssued ? "Update" : "Marked NDC Issued"}
              </button>
              {IsNDCIssued && (
                <>
                  <button
                    className="btn btn btn-aqua"
                    onClick={() => this.sendNoDues()}
                  >
                    Send NoDues
                  </button>
                  <button
                    className="btn btn btn-aqua mx-2"
                    onClick={() => this.viewNoDues()}
                  >
                    Print
                  </button>
                </>
              )}
              <button
                className="btn btn-gray "
                onClick={() => this.handleCancel()}
              >
                Back
              </button>
            </div>
          </div>
          <Footer />
        </div>

        <Modal
          isOpen={isOpen}
          onRequestClose={() => this.setState({ isOpen: false })}
        >
          {/* <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Additional Furniture</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div>
                            </div>

                        </div>
                    </div> */}

          {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

          <div class="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4">
              {/* Header */}
              <div className="modal-header rounded-top-4 p-2">
                <h6 className="modal-title"> Add DD Details</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => this.handleModalCancel()}
                />
              </div>
              {/* Body */}
              <div className="modal-body">
                {vendorList.length > 0 ? (
                  vendorList.map((data, parentIndex) => (
                    <>
                      {vendorIndex == parentIndex && (
                        <div>
                          {data.ExhStallPossessionVendorDDdetailsID &&
                            <div className="dd-checkbox text-white">
                              <label className="mt-1" style={{ cursor: 'pointer' }}>
                                <input
                                  type="checkbox"
                                  checked={data.IsDDSubmitted}
                                  onChange={(e) =>
                                    this.handleInput(
                                      e,
                                      "checkbox",
                                      "IsDDSubmitted",
                                      parentIndex,
                                      null,
                                      data.ExhStallPossessionVendorDDdetailsID
                                    )
                                  }
                                />
                                Tag DD Received
                              </label>
                            </div>
                          }
                          <div className="row g-3 mb-3">
                            <div className="col-md-3 mt-0">
                              <label className="form-label">
                                DD Number<span className="text-red">*</span>
                              </label>
                              <input
                                type="text"
                                maxLength={100}
                                value={data.DD_Number}
                                className="form-control"
                                onChange={(e) =>
                                  this.handleInput(
                                    e,
                                    "varchar",
                                    "DD_Number",
                                    parentIndex
                                  )
                                }
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {data.DD_NumberErr}
                                </span>
                              }
                            </div>
                            <div className="col-md-3 mt-0">
                              <label className="form-label">
                                DD Date<span className="text-red">*</span>
                              </label>
                              <DatePicker
                                style={{ zIndex: "99999" }}
                                selected={
                                  data.DD_Date ? new Date(data.DD_Date) : null
                                }
                                dateFormat={"dd/MM/yyyy"}
                                className="form-control"
                                onChange={(e) =>
                                  this.handleInput(
                                    e,
                                    "date",
                                    "DD_Date",
                                    parentIndex
                                  )
                                }
                                peekNextMonth
                                // minDate={fromDate}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText="To Date"
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {data.DD_DateErr}
                                </span>
                              }
                            </div>
                            <div className="col-md-3 mt-0">
                              <label className="form-label">
                                DD Amount<span className="text-red">*</span>
                              </label>
                              <input
                                type="text"
                                value={data.DD_Amount}
                                maxLength={100}
                                className="form-control"
                                onChange={(e) =>
                                  this.handleInput(
                                    e,
                                    "int",
                                    "DD_Amount",
                                    parentIndex
                                  )
                                }
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {data.DD_AmountErr}
                                </span>
                              }
                            </div>
                            <div className="col-md-3 mt-0">
                              <label className="form-label">
                                Bank Name<span className="text-red">*</span>
                              </label>
                              <input
                                type="text"
                                value={data.DD_BankName}
                                maxLength={200}
                                className="form-control"
                                onChange={(e) =>
                                  this.handleInput(
                                    e,
                                    "varchar",
                                    "DD_BankName",
                                    parentIndex
                                  )
                                }
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {data.DD_BankNameErr}
                                </span>
                              }
                            </div>
                          </div>

                          <div className="mt-3">
                            {/* DD Submitted By */}
                            <div class="card shadow-none border rounded-3 p-0"><div class="card-header  text-dark py-2 bg-card-header">
                              DD Submitted By
                            </div>
                              <div
                                className="card-body p-0"
                                id="submittedSection"
                              >
                                <div className="rounded p-2 mb-0">
                                  <div className="row g-2">
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Company Name
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        value={data.DD_SubmitCompanyName}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_SubmitCompanyName",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_SubmitCompanyNameErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Person Name
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        value={data.DD_SubmitPersonName}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_SubmitPersonName",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_SubmitPersonNameErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Email<span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="email"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        value={data.DD_SubmitEmailId}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_SubmitEmailId",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_SubmitEmailIdErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Mobile No
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={10}
                                        value={data.DD_SubmitMobileNo}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "int",
                                            "DD_SubmitMobileNo",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_SubmitMobileNoErr}
                                        </span>
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* DD Returned By */}
                            <div class="card shadow-none border rounded-3 p-0">
                              <div class="card-header  text-dark py-2 bg-card-header">
                                DD Return To
                              </div>
                              <div
                                className="card-body p-0"
                                id="submittedSection"
                              >
                                <div className="rounded p-2 mb-0">
                                  <div className="row g-2">

                                    <div className="">
                                      <label className="d-flex align-items-center">
                                        <input
                                          type="checkbox"
                                          value={`SameAsAbove_${parentIndex}`}
                                          checked={data.SameAsAbove}
                                          onChange={(e) =>
                                            this.handleInput(
                                              e,
                                              "checkbox",
                                              "SameAsAbove",
                                              parentIndex
                                            )
                                          }
                                          className="mr-2 m-1 me-2"
                                        />
                                        Same as above
                                      </label>
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Company Name
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        disabled={data.SameAsAbove}
                                        value={data.DD_ReturnCompanyName}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_ReturnCompanyName",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_ReturnCompanyNameErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Person Name
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        disabled={data.SameAsAbove}
                                        value={data.DD_ReturnPersonName}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_ReturnPersonName",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_ReturnPersonNameErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Email<span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="email"
                                        className="form-control form-control-sm w-100"
                                        maxLength={100}
                                        disabled={data.SameAsAbove}
                                        value={data.DD_ReturnEmailId}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "varchar",
                                            "DD_ReturnEmailId",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_ReturnEmailIdErr}
                                        </span>
                                      }
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-1">
                                        Mobile No
                                        <span className="text-red">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        maxLength={10}
                                        disabled={data.SameAsAbove}
                                        value={data.DD_ReturnMobileNo}
                                        onChange={(e) =>
                                          this.handleInput(
                                            e,
                                            "int",
                                            "DD_ReturnMobileNo",
                                            parentIndex
                                          )
                                        }
                                      />
                                      {
                                        <span className="text-danger text-start text-left d-block mt-1">
                                          {data.DD_ReturnMobileNoErr}
                                        </span>
                                      }
                                    </div>

                                    <div class="card shadow-none border-0 mt-1 mb-0">
                                      <div class="text-dark py-2 fw-bold text-muted">
                                        Photo ID{" "}
                                        <small>
                                          (Government Approved Document)
                                        </small>
                                      </div>
                                      <div class="card-body border rounded p-2">
                                        <div class="row g-2 align-items-center">
                                          <div class="col-md-3">
                                            <label class="form-label mb-1">
                                              Capture / Upload Photo
                                            </label>
                                            {data.FileName != null &&
                                              data.FilePath != null ? (
                                              <>
                                                {data.FileName != null &&
                                                  data.FileType != null ? (
                                                  <div
                                                    className="d-flex"
                                                    style={{
                                                      justifyContent: "left",
                                                    }}
                                                  >
                                                    <div className="chooseStallFile m-0">
                                                      <p
                                                        className="overflow-membership m-0"
                                                        onClick={() =>
                                                          this.handleViewFile(
                                                            data.FilePath
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        {data.FileName}
                                                      </p>
                                                      <span
                                                        className="membership_file_cross text-danger"
                                                        onClick={() =>
                                                          this.handleRemoveFile(
                                                            parentIndex
                                                          )
                                                        }
                                                      >
                                                        X
                                                      </span>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div
                                                    className="d-flex"
                                                    style={{
                                                      justifyContent: "left",
                                                    }}
                                                  >
                                                    <div className="chooseStallFile m-0">
                                                      <a
                                                        className="overflow-membership m-0"
                                                        target="_blank"
                                                        href={
                                                          BASE_URL.split(
                                                            "/api"
                                                          )[0] + data.FilePath
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        {data.FileName}
                                                      </a>
                                                      <span
                                                        className="membership_file_cross text-danger"
                                                        onClick={() =>
                                                          this.handleRemoveFile(
                                                            parentIndex
                                                          )
                                                        }
                                                      >
                                                        X
                                                      </span>
                                                    </div>
                                                  </div>
                                                )}
                                              </>
                                            ) : (
                                              <div class="d-flex align-items-center">
                                                <button
                                                  class="btn btn-aqua"
                                                  onClick={() =>
                                                    this.handleOpenModal(
                                                      parentIndex
                                                    )
                                                  }
                                                >
                                                  <i class="bi bi-camera"></i>{" "}
                                                  Open Camera
                                                </button>

                                                <span class="mx-2 text-muted">
                                                  or
                                                </span>
                                                <input
                                                  type="file"
                                                  class="form-control form-control-sm w-100 w-auto"
                                                  id="inputGroupFile"
                                                  onChange={(e) =>
                                                    this.handleInput(
                                                      e,
                                                      "file",
                                                      "Document",
                                                      parentIndex
                                                    )
                                                  }
                                                  accept={
                                                    ".jpg,.jpeg,.png,.pdf"
                                                  }
                                                />
                                                <span className="text-danger" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                                                  Max 5MB | Pdf,Jpeg,Jpg,Png only
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                          {
                                            <span className="text-danger text-start text-left d-block mt-1">
                                              {data.FileNameErr}
                                            </span>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Add Subcontractor Button */}
                          <div className="mb-2 mt-3">
                            <button
                              type="button"
                              className="btn btn-aqua p-1"
                              onClick={() => {
                                const updatedList = [...this.state.vendorList];
                                updatedList[parentIndex].subContractorList.push(
                                  {
                                    CompanyName: "",
                                    PersonName: "",
                                    EmailId: "",
                                    MobileNo: "",
                                  }
                                );
                                this.setState({ vendorList: updatedList });
                              }}
                            >
                              <i className="ri-add-line me-1" /> Add
                              Subcontractor
                            </button>
                          </div>

                          {/* Subcontractor Table */}
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                              <thead className="table-light">
                                <tr>
                                  <th>Company Name</th>
                                  <th>Person Name</th>
                                  <th>Email</th>
                                  <th>Mobile No</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.subContractorList.length > 0 ? (
                                  data.subContractorList.map(
                                    (item, childIndex) => (
                                      <tr key={childIndex}>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.CompanyName}
                                            maxLength={100}
                                            className="form-control"
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "varchar",
                                                "CompanyName",
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.PersonName}
                                            maxLength={100}
                                            className="form-control"
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "varchar",
                                                "PersonName",
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.EmailId}
                                            maxLength={100}
                                            className="form-control"
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "varchar",
                                                "EmailId",
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={item.MobileNo}
                                            maxLength={10}
                                            className="form-control"
                                            onChange={(e) =>
                                              this.handleInput(
                                                e,
                                                "int",
                                                "MobileNo",
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="text-center">
                                          <i
                                            className="fa fa-trash text-danger"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.handleDelete(
                                                parentIndex,
                                                childIndex
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      Record not found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </>
                  ))
                ) : (
                  <div className="text-center">Record not found</div>
                )}
              </div>
              <div className="modal-footer py-1">
                <button
                  type="button"
                  className="btn btn-aqua"
                  onClick={() => this.onSaveModal()}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-gray"
                  onClick={() => this.handleModalCancel()}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
          <ImageCapture
            isOpen={isImageModal}
            onClose={this.handleCloseModal}
            onCapture={this.handleCapture}
          />
        </Modal>

        <Modal
          isOpen={isConfirm}
          onRequestClose={() => this.setState({ isConfirm: false })}
        >
          <div class="modal-dialog modal-s modal-dialog-centered">
            <div className="modal-content shadow-lg border-0 rounded-4">
              {/* Header */}
              <div className="modal-header rounded-top-4 p-2">
                <h6 className="modal-title"> Confirm!</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => this.setState({ isConfirm: false })}
                />
              </div>
              {/* Body */}
              <div className="modal-body">
                <h6>Do you want to mark this DD as received and acknowledge it to the contractor?</h6>
              </div>
              <div className="modal-footer py-1">
                <button
                  type="button"
                  className="btn btn-aqua"
                  onClick={() => this.tagDDSubmit(this.state.ExhStallPossessionVendorDDdetailsID, true, true)}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-gray"
                  onClick={() => this.setState({ isConfirm: false })}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getExhStallPossessionDetails_action,
    updateExhStallPossessionChecklist_action,
    getStallPossession_action,
    insertStallPossession_action,
    sendNoDues_action,
    download_no_due_action,
    tagDDSubmit_action
  })(StallPossessionChecklistAU)
);
